<template>
  <div class="menu">
    <MenuItem v-for="item in list" :key="item.id"
      :lang="lang"
      :item="item"
      :responsive="responsive" />
  </div>
</template>

<script>
import MenuItem from '@/components/Nav/MenuItem.vue'

export default {
  name: 'MenuList',
  props: [
    'lang',
    'list',
    'responsive'
  ],
  components: {
    MenuItem
  }
}
</script>
